export const strategyKeys = {
  lifecycle: (locationId: string) => ['strategy-lifecycle', locationId] as const,
  insights: (locationId: string, version?: number) =>
    version !== undefined
      ? (['strategy-insights', locationId, version] as const)
      : (['strategy-insights', locationId] as const),
  overview: (locationId: string) => ['strategy-overview', locationId] as const,
  radius: (locationId: string) => ['strategy-radius', locationId] as const,
  competitorsDensity: (locationId: string) => ['strategy-competitors-density', locationId] as const,
  marketIntel: (locationId: string) => ['strategy-market-intel', locationId] as const,
  competitors: (locationId: string) => ['strategy-competitors', locationId] as const,
  competitorAnalysis: (locationId: string) => ['strategy-competitor-analysis', locationId] as const,
  enrichment: (locationId: string) => ['strategy-enrichment', locationId] as const,
  uploads: (locationId: string) => ['strategy-uploads', locationId] as const,
  extraction: (locationId: string) => ['strategy', 'extraction', locationId] as const,
  questions: (locationId: string) => ['strategy', 'questions', locationId] as const,
  responses: (locationId: string) => ['strategy', 'responses', locationId] as const,
  practiceCoords: (locationId: string) => ['practice-coords', locationId] as const,
  brandProfile: (locationId: string) => ['strategy', 'brand-profile', locationId] as const,
  brandKit: (locationId: string) => ['strategy', 'brand-kit', locationId] as const,
  brandPlatform: (locationId: string) => ['strategy', 'brand-platform', locationId] as const,
  vapiCalls: (practiceId: string) => ['strategy', 'vapi-calls', practiceId] as const,
  vapiSession: (locationId: string) => ['strategy', 'vapi-session', locationId] as const,
  vapiToken: (token: string) => ['strategy', 'vapi-token', token] as const,
};
